import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Typography} from "@deere/fuel-react";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import React from "react";
import {useStyles} from "./styles/Filter";

export const Filter = props => {
    const classes = useStyles();
    return <div className={classes.root}>
        <Accordion expanded={props.expanded}
                   onChange={props.onChange}>
            <AccordionSummary
                className={classes.accordionSummary}
                classes={{content: classes.content, expanded: classes.expanded}}
                expandIcon={<ExpandMoreIcon style={{fontSize: "2rem"}}/>}
                aria-controls="criteria-status-filter"
                id="criteria-status-filter"
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography>{props.name}</Typography>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails className={classes.statusContent}>
                <FormControl component="fieldset">
                    <FormGroup>
                        {props.statusList && props.statusList.map((list, index) => {
                            return (
                                <FormControlLabel key={index} className={classes.root} onChange={props.onFilterUpdate}
                                                  control={<Checkbox checked={list.checked} name={list.name}/>}
                                                  label={list.label}/>
                            )
                        })}
                    </FormGroup>
                </FormControl>
            </AccordionDetails>
        </Accordion>
    </div>;
}